(() => {
  const escapeHTML = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  document.querySelectorAll('[data-predictive-search]').forEach((root) => {
    const input = root.querySelector('input[type="search"]');
    const results = root.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    let timer;

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      const query = input.value.trim();
      if (query.length < 2) {
        results.innerHTML = '';
        results.hidden = true;
        return;
      }
      timer = window.setTimeout(async () => {
        try {
          const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,page,article&resources[limit]=6&resources[options][unavailable_products]=hide`;
          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Búsqueda no disponible');
          const data = await response.json();
          const resources = data.resources?.results || {};
          const items = [...(resources.products || []), ...(resources.pages || []), ...(resources.articles || [])];
          if (!items.length) {
            results.innerHTML = '<p class="stoa-meta">No encontramos resultados.</p>';
          } else {
            results.innerHTML = `<ul>${items.map((item) => `
              <li>
                <a href="${escapeHTML(item.url)}">
                  ${item.image ? `<img src="${escapeHTML(item.image)}&width=112" width="56" height="56" loading="lazy" alt="">` : '<span></span>'}
                  <span><strong>${escapeHTML(item.title)}</strong>${item.price ? `<br><small>${escapeHTML(item.price)}</small>` : ''}</span>
                </a>
              </li>
            `).join('')}</ul>`;
          }
          results.hidden = false;
        } catch (error) {
          results.innerHTML = '<p class="stoa-meta">No fue posible cargar sugerencias.</p>';
          results.hidden = false;
        }
      }, 220);
    });
  });
})();
